import { Component, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

@Component({
	selector: 'app-loading-spinner-dialog',
	templateUrl: './loading-spinner-dialog.component.html',
	styleUrls: ['./loading-spinner-dialog.component.scss'],
})
export class LoadingSpinnerDialogComponent implements OnInit {
	constructor(private dialogRef: MatDialogRef<LoadingSpinnerDialogComponent>) {
		dialogRef.disableClose = true;
	}

	ngOnInit() {}
}
